import { CompanyProfile, CompanyProfileBenefitEndpoint } from '../types';

export default class CompanyBenefitsSerializers {
  static toJSON(company: Pick<CompanyProfile, 'benefits'>) {
    return {
      company_benefits: company.benefits?.map((benefit: any) => ({
        resource_id: benefit.resourceId,
        category: {
          category_key: benefit.category.categoryKey,
          labels: {
            en: benefit.category.labels?.en || '',
            de: benefit.category.labels?.de || '',
          },
        },
        benefit_key: benefit.benefitKey,
        selected_at: benefit.selectedAt,
        labels: {
          en: benefit.labels?.en || '',
          de: benefit.labels?.de || '',
        },
      })),
    };
  }

  static toObject(payload: CompanyProfileBenefitEndpoint): {
    benefits: CompanyProfile['benefits'];
  } {
    return {
      benefits: payload.company_benefits?.map((benefit) => ({
        resourceId: benefit.resource_id,
        category: {
          categoryKey: benefit.category.category_key,
          labels: {
            en: benefit.category.labels?.en || '',
            de: benefit.category.labels?.de || '',
          },
        },
        benefitKey: benefit.benefit_key,
        selectedAt: benefit.selected_at,
        labels: {
          en: benefit.labels?.en || '',
          de: benefit.labels?.de || '',
        },
      })),
    };
  }
}
